import { render } from "./IndexMenu.vue?vue&type=template&id=55d4dbad"
import script from "./IndexMenu.vue?vue&type=script&lang=js"
export * from "./IndexMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__